export const sleep = (timeout = 0) => new Promise<void>(r => setTimeout(r, timeout));

export class Mutex {
  private queue: (() => void)[] = [];
  public async Lock() {
    if (this.queue.length > 0) {
      await new Promise<void>(r => this.queue.push(r));
    } else {
      this.queue.push(undefined as unknown as () => void);
    }
  }
  public Unlock() {
    this.queue.shift();
    this.queue[0]?.();
  }
}
